import { render, staticRenderFns } from "./Pc.vue?vue&type=template&id=1a67c274&scoped=true"
import script from "./Pc.vue?vue&type=script&lang=js"
export * from "./Pc.vue?vue&type=script&lang=js"
import style0 from "./Pc.vue?vue&type=style&index=0&id=1a67c274&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a67c274",
  null
  
)

export default component.exports